import { render, staticRenderFns } from "./ScannedRecordTable.vue?vue&type=template&id=6dbd555e&"
import script from "./ScannedRecordTable.vue?vue&type=script&lang=js&"
export * from "./ScannedRecordTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports